import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1243.56141,1811.41082 L1005.25553,1175.21318 L732.389647,1813.33082 C629.161412,1810.73318 569.302588,1748.50259 569.302588,1748.50259 L162.601412,471.589647 C162.601412,471.589647 146.563765,408.229647 55.7590588,408.229647 L-0.0338823529,408.229647 L37.0108235,312.003765 L556.766118,312.003765 L556.766118,408.229647 C556.766118,408.229647 505.152,449.792 517.236706,507.392 C529.434353,564.992 737.472,1394.65788 737.472,1394.65788 L938.055529,950.686118 L844.992,657.039059 C809.302588,566.799059 779.937882,479.834353 756.559059,456.794353 C723.580235,420.992 663.495529,408.229647 663.495529,408.229647 L663.495529,312.003765 L1303.872,312.003765 L1303.872,408.229647 L1197.93318,408.229647 C1197.93318,408.229647 1142.14024,419.410824 1137.28376,501.406118 C1136.26729,517.895529 1145.86729,575.269647 1145.86729,575.269647 L1394.33788,1392.17318 C1394.33788,1392.17318 1649.58494,923.467294 1653.19906,821.368471 C1656.92612,719.495529 1617.39671,552.681412 1505.92376,486.046118 C1327.58965,378.639059 1372.65318,164.954353 1510.10259,89.3967059 C1568.832,57.2084706 1621.12376,55.9661176 1680.64376,55.9661176 C1890.48847,55.9661176 1914.09318,293.820235 1914.09318,293.820235 C1927.98494,375.815529 1918.15906,515.297882 1878.62965,638.290824 C1775.40141,958.140235 1519.92847,1533.57553 1420.992,1752.68141 C1341.48141,1831.62729 1243.56141,1811.41082 1243.56141,1811.41082",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconWordpressSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconWordpressSolid, _Component);

  var _super = _createSuper(IconWordpressSolid);

  function IconWordpressSolid() {
    _classCallCheck(this, IconWordpressSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconWordpressSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconWordpress",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconWordpressSolid.displayName = "IconWordpressSolid";
  return IconWordpressSolid;
}(Component);

IconWordpressSolid.glyphName = 'wordpress';
IconWordpressSolid.variant = 'Solid';
IconWordpressSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconWordpressSolid;
export { IconWordpressSolid };